// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1l_7E","col":"styles_col__12I9k"};